import _ from 'lodash';

class AutoRefreshCheckController {
  /* @ngInject */
  constructor(NewBackendService, endPoints, $rootScope) {
    if (MODE !== "admin") return;


    const TIMER_SESSION = 210000; //3,5 min
    const TIMER_MODAL = 60000; //1 min


    let sessionTimeout;
    let modalTimeout;

    const userIsAlreadyLoggedIn = localStorage.getItem("access_token");
    if (userIsAlreadyLoggedIn) {
      startSessionTimeout();
    }

    function showModal() {
      const modal = document.getElementById('modal');
      modal.style.display = 'flex';

      // Imposta un timer per il logout se l'utente non clicca entro 1 minuto
      modalTimeout = setTimeout(logout, TIMER_MODAL);
    }

    function startSessionTimeout() {
      console.log("starting session timeout!")
      sessionTimeout = setTimeout(showModal, TIMER_SESSION);
    }

    function renewSession() {
      // Nascondi la modale
      const modal = document.getElementById('modal');
      modal.style.display = 'none';

      // Cancella il timer del logout
      clearTimeout(modalTimeout);

      // Effettua una chiamata al backend per rinnovare il token
      NewBackendService.invokeWebApiGet(`${endPoints.userUrl}/plans/all`)
        .then(() => {
          resetTimeout();
           
        
        })
        .catch(() => {
          resetTimeout();
        });
    }

    function resetTimeout() {
      // Reimposta il timer della sessione a 4 minuti
      clearTimeout(sessionTimeout);
      sessionTimeout = setTimeout(showModal, TIMER_SESSION);
    }

    function logout() {
      $rootScope.$broadcast('doLogout');
    }

    document.getElementById('renewButton').addEventListener('click', renewSession);
    $rootScope.$on('xhr', resetTimeout);
    $rootScope.$on('USER_LOGGED_IN', () => {
      startSessionTimeout();
    });
    $rootScope.$on('USER_LOGGED_OUT', () => {
      console.log("stopping session timeout!")
      clearTimeout(sessionTimeout);
      const modal = document.getElementById('modal');
      modal.style.display = 'none';
      clearTimeout(modalTimeout);
    });

  }
}

export default AutoRefreshCheckController;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/autoRefreshCheck/autoRefreshCheck.controller.js
 **/